import React from "react";
import { List } from "../modules/Settings/Prices";

export function PricesListPage() {
  return <List />;
}
